import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { PortalService } from '../../../../services/portal/portal.service';

@Component({
  selector: 'app-existing-submission-banner',
  templateUrl: './existing-submission-banner.component.html',
  styleUrls: ['./existing-submission-banner.component.scss']
})
export class ExistingSubmissionBannerComponent {
  @Input() subText = $localize`Further edits to this section will not be allowed during this time.`;
  @Output() linkClicked = new EventEmitter<void>();

  public isInternal$ = inject(PortalService).isInternal$;
}
